import React, { useEffect, useRef } from 'react';
import styles from './styles.css.js';
export var LiveRegion = function (_a) {
    var message = _a.message, _b = _a.atomic, atomic = _b === void 0 ? true : _b;
    // When react updates a node, NVDA registers
    // many separate live region updates and announces them all.
    // This way we are guaranteed to update the live region only once
    // https://github.com/nvaccess/nvda/issues/7996
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current !== null) {
            ref.current.textContent = message;
        }
    }, [message]);
    return (React.createElement("div", { ref: ref, className: styles.root, "aria-live": "assertive", "aria-atomic": atomic ? 'true' : 'false', key: "live-region" }));
};
//# sourceMappingURL=index.js.map